// @ts-nocheck TODO
/**
 * Runs code required to render the work's scribd attachment(s).
 * Creates timeout to handle scribd not loading state.
 * Hides relevant content when scribd is down.
 * Registers click handler for readPaperButton.
 */
import ResponsiveScribdDocumentView from 'js/core_post_webpack/responsive_scribd_view';
import AttachmentPreviewController from 'js/single_work/attachment_preview_controller';
import { trackClick } from 'js/utils/trackClick';
import { PreviewableAttachment, Work } from './types';

function setUpScribdDocument({
  previewableAttachments,
  work,
  hasViewableAttachments,
}: {
  previewableAttachments: PreviewableAttachment[];
  work: Work;
  hasViewableAttachments: boolean;
}): void {
  const readPaperButton = document.querySelector('.js-read-paper-button');
  const readPaperButtonFade = document.querySelector(
    '.js-read-paper-button-fade',
  );

  previewableAttachments.forEach((attachment) => {
    const docView = new ResponsiveScribdDocumentView({
      el: `.attachment_preview[data-attachment='${attachment.identifier}']`,
      attachmentId: attachment.id,
      isLoggedIn: false,
      shouldShowBulkDownload: attachment.shouldShowBulkDownload,
      work: work,
    });

    window.SingleWork.register_preview_view(attachment.identifier, docView);

    setTimeout(() => {
      if (
        document
          .querySelector('.js-scribd-document-loader')
          ?.hasAttribute('visible')
      ) {
        document.querySelector('.js-preview-unavailable').style.display =
          'block';
        document.querySelector('.js-scribd-document-container').style.display =
          'none';
        // for toggling some classes that exist to prevent layout shift
        // (should match event in responsive_scribd_view's _onDocReady)
        window.dispatchEvent(new Event('scribdLoadingEnded'));
        if (readPaperButton != null) readPaperButton.style.display = 'none';
        if (readPaperButtonFade != null)
          readPaperButtonFade.style.display = 'none';
      }
    }, 30000);
  });

  if (hasViewableAttachments) {
    if (previewableAttachments.length > 0) {
      const attachment = {
        index: 0,
        id: previewableAttachments[0].identifier,
      };
      new AttachmentPreviewController({
        attachment: attachment,
        multiple_viewable_attachments: previewableAttachments.length > 1,
      });
    }
  }

  // read_paper_button
  const aboveFoldEl = document.querySelector('.js-swp-splash-above-fold');
  readPaperButton?.addEventListener('click', () => {
    trackClick({ source: 'loswp--read-paper-button', bucket: 'fast' });

    readPaperButton.style.display = 'none';
    if (readPaperButtonFade != null) readPaperButtonFade.style.display = 'none';

    aboveFoldEl.classList.add('clicked');
  });
}

export default setUpScribdDocument;
